/* NATIONALIS Warenkorb (ohne App): Versand-Hinweis mit Countdown, Kits per Klick in den Warenkorb,
   Warenkorb-Schublade oeffnet nach "In den Warenkorb" auf der Produktseite. */
import { CartAddEvent } from '@theme/events';

const TZ = 'Europe/Berlin';
const DAY = 86400000;
// Tage ohne Versand (Monat-Tag). An allen anderen Tagen wird verschickt, auch sonntags.
const NO_SHIP = ['12-25', '12-26', '01-01'];
const WEEKDAYS = {
  de: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
  en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
};

const berlinFormat = new Intl.DateTimeFormat('en-GB', {
  timeZone: TZ,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23',
});

function berlinNow() {
  const p = {};
  for (const part of berlinFormat.formatToParts(new Date())) p[part.type] = part.value;
  return { y: +p.year, m: +p.month, d: +p.day, h: +p.hour % 24, mi: +p.minute, s: +p.second };
}

function isNoShipDay(t) {
  const d = new Date(t);
  const key = String(d.getUTCMonth() + 1).padStart(2, '0') + '-' + String(d.getUTCDate()).padStart(2, '0');
  return NO_SHIP.includes(key);
}

function shipText(lang, startHour) {
  const de = lang === 'de';
  const now = berlinNow();
  const today = Date.UTC(now.y, now.m - 1, now.d);
  let ship = today + DAY;
  while (isNoShipDay(ship)) ship += DAY;
  const days = Math.round((ship - today) / DAY);
  const weekday = WEEKDAYS[de ? 'de' : 'en'][new Date(ship).getUTCDay()];
  const when = days === 1 ? (de ? 'morgen' : 'tomorrow') : (de ? 'am ' : 'on ') + weekday;

  if (now.h >= startHour) {
    const left = DAY / 1000 - (now.h * 3600 + now.mi * 60 + now.s);
    const hours = Math.floor(left / 3600);
    const minutes = Math.floor((left % 3600) / 60);
    let duration;
    if (hours > 0) duration = de ? hours + ' Std. ' + minutes + ' Min.' : hours + ' h ' + minutes + ' min';
    else duration = de ? Math.max(1, minutes) + ' Min.' : Math.max(1, minutes) + ' min';
    return de
      ? 'Noch <b>' + duration + '</b>: heute bestellt, ' + when + ' verschickt.'
      : 'Order within <b>' + duration + '</b> and it ships ' + when + '.';
  }
  return de ? 'Heute bestellt, <b>' + when + ' verschickt</b>.' : 'Order today, <b>ships ' + when + '</b>.';
}

function renderShipping() {
  for (const el of document.querySelectorAll('[data-nx-ship]')) {
    const target = el.querySelector('[data-nx-ship-text]');
    if (!target) continue;
    const html = shipText(el.getAttribute('data-lang') || 'de', parseInt(el.getAttribute('data-start') || '18', 10));
    if (target.innerHTML !== html) target.innerHTML = html;
  }
}

let scheduled = false;
function scheduleRender() {
  if (scheduled) return;
  scheduled = true;
  requestAnimationFrame(() => {
    scheduled = false;
    renderShipping();
  });
}

renderShipping();
setInterval(renderShipping, 20000);
new MutationObserver((mutations) => {
  for (const m of mutations) {
    const node = m.target instanceof Element ? m.target : m.target.parentElement;
    if (node && node.closest('cart-items-component, [data-nx-ship]')) {
      scheduleRender();
      return;
    }
  }
}).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

function cartSectionIds() {
  const ids = new Set();
  for (const el of document.querySelectorAll('cart-items-component')) {
    if (el instanceof HTMLElement && el.dataset.sectionId) ids.add(el.dataset.sectionId);
  }
  return [...ids];
}

async function addVariant(button) {
  const kit = button.closest('.nx-kit');
  const message = kit ? kit.querySelector('[data-nx-msg]') : null;
  const langEl = button.closest('[data-lang]');
  const lang = langEl ? langEl.getAttribute('data-lang') : 'de';
  const buttons = kit ? [...kit.querySelectorAll('[data-nx-add]')] : [button];
  const wasDisabled = buttons.map((b) => b.disabled);
  buttons.forEach((b) => (b.disabled = true));
  button.classList.add('is-loading');
  if (message) message.hidden = true;

  const sections = cartSectionIds();
  const url = (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(button.getAttribute('data-nx-add')), quantity: 1 }],
        sections: sections.join(','),
        sections_url: window.location.pathname,
      }),
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || '');

    let itemCount;
    for (const id of sections) {
      const html = data.sections && data.sections[id];
      if (!html) continue;
      const count = new DOMParser().parseFromString(html, 'text/html').querySelector('[ref="cartItemCount"]');
      if (count) {
        itemCount = parseInt(count.textContent || '0', 10);
        break;
      }
    }
    if (itemCount === undefined) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const cart = await fetch(root + 'cart.js').then((r) => r.json());
      itemCount = cart.item_count;
    }

    document.dispatchEvent(
      new CartAddEvent({}, 'nx-cart-upsell', {
        source: 'nx-cart-upsell',
        itemCount,
        variantId: button.getAttribute('data-nx-add') || undefined,
        sections: data.sections,
      })
    );
  } catch (error) {
    buttons.forEach((b, i) => (b.disabled = wasDisabled[i]));
    button.classList.remove('is-loading');
    if (message) {
      const reason = error instanceof Error && error.message ? ' ' + error.message : '';
      message.textContent = (lang === 'de' ? 'Das hat nicht geklappt.' : 'That did not work.') + reason;
      message.hidden = false;
    }
  }
}

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target.closest('[data-nx-add]') : null;
  if (!(target instanceof HTMLButtonElement) || target.disabled) return;
  event.preventDefault();
  addVariant(target);
});

// Nach "In den Warenkorb" auf der Produktseite die Schublade oeffnen, damit Duo-Balken und Kits sofort zu sehen sind.
document.addEventListener('cart:update', (event) => {
  const data = event.detail && event.detail.data;
  if (!data || data.source !== 'product-form-component' || data.didError) return;
  const drawer = document.querySelector('cart-drawer-component');
  if (!drawer || drawer.hasAttribute('auto-open') || typeof drawer.open !== 'function') return;
  setTimeout(() => drawer.open(), 250);
});